import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider, FieldArray } from "formik";
import {  Apitoken, Authtoken } from "../Global";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
import  "./../assets/css/custom.css"; 

const SupplychainPackagelistHeadersAdd = () => {
  const [ordersLists, setOrdersLists] = useState([]);
  const [productLists, setproductLists] = useState([]);
  const [packagingTypesLists, setPackagingTypesLists] = useState([]);
  // const [palletsTypesLists, setPalletsTypesLists] = useState([]);
  const [ggnLists, setGgnLists] = useState([]);
  const [permission, setPermission] = useState({});

  // const [productionsoutputLists, setProductionsoutputLists] = useState([]);
  const [menu, setMenu] = useState(false);
  const [showTableHeadings, setShowTableHeadings] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  const [transportSuppliers, setTransportSuppliers] = useState([]);
  const [productionTypes, setProductionTypes] = useState([]);
  const [orderItems, setOrderItems] = useState([]);
  // const [autonewweight, setAutonewweight] = useState('');
  const [orderggnnumber, setOrderggnnumber] = useState('');
  const currencySymbol =('€');

    let season_id = localStorage.getItem("season_id");


  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [defaultDate, setDefaultDate] = useState(formatDate(new Date()));

//  console.log(defaultDate);

  const formik = useFormik({
    initialValues: {
      order: "",
      season_id:season_id,
      truck_number: "",
      seal_number: "",
      transport_company: "",
      dat_of_loading: defaultDate,
      total_net_weight: "",
      total_brut_weight: "",
      production_type: "",
      contents: orderItems,
      expedition_date:defaultDate,
      remarks:'',
      items: [],
    },
    onSubmit: (values, { setSubmitting }) => {
      axios
        .post("/supply-chain-packaging-list-header/add", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          $("#form-submit").text("Add Supply Chain Packaging");
          delete backendErrors['error'];
        //  actions.setSubmitting(false);
        setSubmitting(false);
          if (response.data.code === 200) {
            toast.success(response.data.message);
           // actions.resetForm();
            setTimeout(() => {
              window.location.href = "/supplychain-package-lists";
            }, 1000);
          }  else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }


        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  const getCustomerGNN = (event) => {

    const order_id = event.value;
    if(order_id !=""){
      axios
      .get(`/production-output/gnn-by-order-from-production/${season_id+'-'+order_id}`,  {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setOrderggnnumber(response.data.data.numbers);

        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }

    if(order_id !=""){
    axios
      .get(`/production-output/gnn-by-order/${season_id+'-'+order_id}`,  {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let orders = response.data.data.numbers;

          let orderlisting = orders.map((ord, index) => ({
            label: ord.ggn_number,
            value: ord.ggn_number,
            key: `order-${index}`,
          }));
          setGgnLists(orderlisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }
  }
  useEffect(() => {
        setPermission(FindModuleById(91)); 
console.log(permission);
var para ={season_id:season_id};
    axios
      .post(
        "/orders/listing-produced",
        para,
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let orders = response.data.data.orders;
          let orderslisting = orders.map((customer, index) => ({
            label: customer.po_number,
            value: customer.id,
            key: `address-${index}`,
          }));
          setOrdersLists(orderslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
      axios .post( "/products/listing-category-type", {}, {  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, }
      ).then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.products;
          let productslisting = products.map((customer, index) => ({
            // label: customer.name + " ("+customer.category.title+") "+ " ("+customer.type.title+")",
            label: customer.productname ,value: customer.id,
            key: `address-${index}`,
          }));
          setproductLists(productslisting);
         
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  

      axios
      .get(`/helpers/production-types`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let transport_types = response.data.data.types;
          let transportlisting = transport_types.map((ord, index) => ({
            label: ord.title,
            value: ord.id,
            key: `typ-${index}`,
          }));
          setProductionTypes(transportlisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  
      axios
    .get(`/helpers/transport-supplier`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    })
    .then((response) => {
      if (response.data.code === 200) {
        let transport_types = response.data.data.supplier;
        let transportlisting = transport_types.map((ord, index) => ({
          label: ord.name,
          value: ord.id,
          key: `supplier-${index}`,
        }));
        setTransportSuppliers(transportlisting);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });
    axios
      .get("/helpers/production-output-packaging-types-packaging", {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let materials_payment_status =
            response.data.data.materials_payment_status;
          let productionlisting = materials_payment_status.map(
            (customer, index) => ({
              label: customer.title,
              value: customer.id,
              key: `typee-${index}`,
            })
          );
          setPackagingTypesLists(productionlisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

  }, []);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };


  const handleGetItemsByOrder = (event) => {
    const order_id = event.value;

    if (order_id != "") {
      
      // axios.get(`/order-items-supply-chain/${order_id}`, {
      //   headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      // })
      axios.get(`/order-items-production-output/${season_id+'-'+order_id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
         // console.log(response.data.data.production_items);
          setOrderItems(response.data.data.production_items);
          var orderitems = response.data.data.production_items;
          let totalGrossWeight = 0;
              let totalNetWeight = 0;

              orderitems.forEach(item => {
                item.products.forEach(product => {
                  totalGrossWeight += product.gross_weight;
                  totalNetWeight += product.net_weight;
                });
              });
              formik.setFieldValue('total_net_weight', totalNetWeight);
              formik.setFieldValue('total_brut_weight', totalGrossWeight);
          //setProductionsoutputLists(response.data.data.order.pallets);

        }
      })
      .catch((error) => {
        console.log(error);
      });

    }
  };



const  productionTypeItem = (event) =>{
  const production_type_id = event.value;
  let order_id = $("#order-ponumber").val();

  console.log(order_id);

  $("#internal-production").hide();
  $("#new-production").hide();

  if(production_type_id == 1){
    $("#internal-production").show();
  }
  if(production_type_id == 2){
    $("#new-production").show();
    if(order_id  == null){
      console.log("error");

    }else{
      console.log("error");

      

    }
  }
}

const inputStyle = {
  // Inline styles to remove the spinner in WebKit browsers
  WebkitAppearance: 'none',
  MozAppearance: 'textfield',
  margin: 0
};

const handleWheel = (event) => {
  // Prevent the default behavior of incrementing/decrementing on scroll
  event.preventDefault();
};



// Function to handle numeric input only, allowing decimal points
const handleNumericInput = (event) => {
  const newValue = event.target.value;
  // const fieldName = event.target.name; // Get the name of the field

  // If the value is numeric or contains a decimal point, allow the input
  if (newValue === '' || /^[0-9\b]+(\.[0-9\b]*)?$/.test(newValue)) {
    formik.handleChange(event); // Use formik's handleChange to update the value
  } else {
    event.preventDefault(); // Prevent the default action if the input is invalid
  }
};

if(formik.values.items.length >0){
// // Calculate total net weight and total gross weight
// const totalNetWeight = formik.values.items.reduce((sum, item) => sum + (parseFloat(item.net_weight) || 0), 0);
// const totalGrossWeight = formik.values.items.reduce((sum, item) => sum + (parseFloat(item.gross_weight) || 0), 0);
// formik.setFieldValue('total_net_weight', totalNetWeight);
// formik.setFieldValue('total_brut_weight', totalGrossWeight);
}


const calculateTotalWeight = (items, field) => {
  return items.reduce((sum, item) => sum + (parseFloat(item[field]) || 0), 0);
};
const handleSelectChange = (name, selectedOption) => {
  const value = selectedOption ? selectedOption.value : "";
  updateFormikValue(name, value);
  customHandleInput({ target: { name, value } });
};

const updateFormikValue = (name, value) => {
  formik.setFieldValue(name, value);
};
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title"> Packing List</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/supplychain-package-lists">
                         Packing List
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Add Packing List
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Packing List Header</h4>
                    <FormikProvider value={formik}>
                      <form onSubmit={formik.handleSubmit}>
                        <div className="row">
                          <div className="col-md-6">
                          <div className="form-group order status">
                              <label>Production Type</label>
                              <Select
                                className="w-100"
                                value={productionTypes.find(option => option.value == formik.values.production_type) || null} // Ensure correct format
                                name="production_type"
                                onChange={(selectedOption) => {
                                handleSelectChange("production_type", selectedOption);
                                productionTypeItem(selectedOption);
                                }}
                                onBlur={formik.handleBlur}
                                options={productionTypes}
                                placeholder="Select"

                            
                              />
                             <small>
                                {backendErrors.production_type && (
                                    <span className="form-error mt-1">
                                      {backendErrors.production_type}
                                    </span>
                                  )}
                              </small>
                            </div>
                            <div className="form-group order status">
                              <label>Order PO Number</label>
                              <Select

                                  className="w-100"
                                  value={ordersLists.find(option => option.value == formik.values.order) || null} // Ensure correct format
                                  name="order"
                                  onChange={(selectedOption) => {
                                  handleSelectChange("order", selectedOption);
                                  handleGetItemsByOrder(selectedOption);
                                  getCustomerGNN(selectedOption);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={ordersLists}
                                  placeholder="Select"

                                // className="form-select form-control"
                                // name="order"
                                // id="order-ponumber"
                                // value={formik.values.order}
                                // onChange={(e) => {
                                //   formik.handleChange(e);
                                //   customHandleInput(e);
                                //   handleGetItemsByOrder(e); // Call the new function to check if the select field should be displayed
                                //   getCustomerGNN(e);
                                // }}
                                // onBlur={formik.handleBlur}
                                // data={ordersLists}
                                // options={{
                                //   placeholder: "Select Order",
                                // }}
                              />
                             <small>
                                {backendErrors.order && (
                                    <span className="form-error mt-1">
                                      {backendErrors.order}
                                    </span>
                                  )}
                              </small>
                            </div>
                                <div className="form-group">
                                <label>GGN Number</label>
                               
                                <select
                                    className="form-select form-control"
                                    name="ggn_number"
                                    value={formik.values.ggn_number}
                                    >
                                  <option  value={orderggnnumber} selected> {orderggnnumber}</option>
                              </select>
                                <small>
                                  {backendErrors.ggn_number && (
                                    <span order="form-error mt-1">
                                      {backendErrors.ggn_number}
                                    </span>
                                  )}
                                </small>
                              </div>

                            <div className="form-group">
                              <label>Seal Number</label>
                              <input
                                type="text"
                                className="form-input form-control"
                                name="seal_number"
                                value={formik.values.seal_number}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                onBlur={formik.handleBlur}
                               
                              />
                             <small>
                                {backendErrors.seal_number && (
                                    <span className="form-error mt-1">
                                      {backendErrors.seal_number}
                                    </span>
                                  )}
                              </small>
                            </div>

                           

                            <div className="form-group">
                              <label>ETD</label>
                              <input
                                type="date"
                                className="form-input form-control"
                                name="dat_of_loading"
                                value={formik.values.dat_of_loading}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                  setDefaultDate(e.target.value);
                                }}
                                onBlur={formik.handleBlur}
                               
                              />
                               <small>
                                {backendErrors.dat_of_loading && (
                                    <span className="form-error mt-1">
                                      {backendErrors.dat_of_loading}
                                    </span>
                                  )}
                              </small>
                            </div>
                          
                            <div className="form-group">
                              <label>Remarks</label>
                              <textarea
                                type="remarks"
                                className="form-input form-control"
                                name="remarks"
                                value={formik.values.remarks}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                 
                                }}
                                onBlur={formik.handleBlur}
                               
                              />
                               <small>
                                {backendErrors.remarks && (
                                    <span className="form-error mt-1">
                                      {backendErrors.remarks}
                                    </span>
                                  )}
                              </small>
                            </div>


                          </div>
                           
                        
                          <div className="col-md-6">
                          <div className="form-group">
                              <label>Expedition Date</label>
                              <input
                                type="date"
                                className="form-input form-control"
                                name="expedition_date"
                                value={formik.values.expedition_date}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                  setDefaultDate(e.target.value);
                                }}
                                onBlur={formik.handleBlur}
                               
                              />
                               <small>
                                {backendErrors.expedition_date && (
                                    <span className="form-error mt-1">
                                      {backendErrors.expedition_date}
                                    </span>
                                  )}
                              </small>
                            </div>
                              <div className="form-group">
                              <label>Truck Number</label>
                              <input
                                type="text"
                                className="form-input form-control"
                                name="truck_number"
                                value={formik.values.truck_number}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                onBlur={formik.handleBlur}
                               
                              />
                               <small>
                                {backendErrors.truck_number && (
                                    <span className="form-error mt-1">
                                      {backendErrors.truck_number}
                                    </span>
                                  )}
                              </small>
                            </div>
                            <div className="form-group status">
                              <label>Transport Company</label>
                              {/* <input
                                type="text"
                                className="form-input form-control"
                                name="transport_company"
                                value={formik.values.transport_company}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                onBlur={formik.handleBlur}
                               
                              /> */}
                              <Select
                                className="w-100"
                                value={transportSuppliers.find(option => option.value == formik.values.transport_company) || null} // Ensure correct format
                                name="transport_company"
                                onChange={(selectedOption) => {
                                handleSelectChange("transport_company", selectedOption);
                                //handleGetItemsByOrder(selectedOption);
                                //getCustomerGNN(selectedOption);
                                }}
                                onBlur={formik.handleBlur}
                                options={transportSuppliers}
                                placeholder="Select"

                                // value={formik.values.transport_company}
                                // name="transport_company"
                                // data={transportSuppliers}
                                // className={
                                //   backendErrors.transport_company
                                //     ? "w-100 input-error"
                                //     : "w-100"
                                // }
                                // onChange={(e) => {
                                //   formik.handleChange(e);
                                //   customHandleInput(e);
                                // }}
                                // onBlur={formik.handleBlur}
                                // options={{
                                //   placeholder: "Select a Transport Supplier",
                                // }}
                              />
                              <small>
                                {backendErrors.transport_company && (
                                    <span className="form-error mt-1">
                                      {backendErrors.transport_company}
                                    </span>
                                  )}
                              </small>
                            </div>
                            <div className="form-group">

                              <label>Total Net Weight</label>
                                    <div className="input-group">
                                        <input type="text" 
                                        name="total_net_weight"
                                        value={formik.values.total_net_weight}
                                        onChange={(e) => {
                                          formik.handleChange(e);
                                          customHandleInput(e);
                                          handleNumericInput(e);
                                        }}
                                       onKeyPress={(event) => {
                                        if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                          event.preventDefault();
                                        }
                                      }}
                                        style={inputStyle}  onWheel={handleWheel}
                                        onBlur={formik.handleBlur}
                                        className="form-control" placeholder="Total Net Weight" aria-label="Total Net Weight" aria-describedby="basic-addon2" />
                                        <div className="input-group-append">
                                            <span className="input-group-text" id="basic-addon2">KG</span>
                                        </div>
                                    </div>
                             
                              <small>
                                {backendErrors.total_net_weight && (
                                    <span className="form-error mt-1">
                                      {backendErrors.total_net_weight}
                                    </span>
                                  )}
                              </small>
                            </div>
                            <div className="form-group">
                              <label>Total Brut Weight</label>
                              
                              <div className="input-group">
                                        <input type="text" 
                                        name="total_brut_weight"
                                        value={formik.values.total_brut_weight}
                                        onChange={(e) => {
                                          formik.handleChange(e);
                                          customHandleInput(e);
                                          handleNumericInput(e);
                                        }}
                                        onKeyPress={(event) => {
                                        if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                          event.preventDefault();
                                        }
                                      }}
                                      
                                        style={inputStyle}  onWheel={handleWheel}
                                        onBlur={formik.handleBlur}
                                        className="form-control" placeholder="Total Brut Weight" aria-label="Total Brut Weight" aria-describedby="basic-addon2" />
                                        <div className="input-group-append">
                                            <span className="input-group-text" id="basic-addon2">KG</span>
                                        </div>
                                    </div>
                                <small>
                                {backendErrors.total_brut_weight && (
                                    <span className="form-error mt-1">
                                      {backendErrors.total_brut_weight}
                                    </span>
                                  )}
                              </small>
                            </div>

                          </div>
                        </div>

                        <div id="internal-production" style={{display:'none'}}>
                        <div className="row">
                          <div className="col-md-6">
                            <h4 className="card-title">
                              <br />
                              Packing List Contents
                            </h4>
                          </div>
                        </div>
                        <FieldArray
                          name="contents"
                          render={() => (
                            <table>
                              <thead>
                                  <td style={{width:'6%'}}>Pallet</td>
                                  <td style={{width:'16%'}}>Production Output</td>
                                  <td style={{width:'16%'}}>GGN Number</td>
                                  <td style={{width:'22%'}}>Product</td>
                                  <td style={{width:'22%'}}>Lot Number</td>
                                  <td style={{width:'10%'}}>Caliber</td>
                                  <td  style={{width:'10%'}}>No of Boxes</td>
                                  <td  style={{width:'10%'}}>Net Weight</td>
                                  <td  style={{width:'10%'}}>Gross Weight</td>
                              </thead>
                           
                              
                              
                                    {orderItems.map((order_item, index) => (
                                <tbody key={order_item.productions_id || index}>
                                  <tr key={order_item.productions_id || index}>
                                    <td style={{ width: "6%" }}>
                                      <input
                                        type="text"
                                        className="form-input form-control"
                                        name={`contents[${index}].pallet_number-${order_item.productions_id}`}
                                        value={index + 1}
                                        onChange={formik.handleChange}
                                      />
                                    </td>
                                    <td style={{ width: "16%" }}>
                                      <select
                                        className="form-select form-control"
                                        name={`contents[${index}].production_output_pallet`}
                                        onBlur={formik.handleBlur}
                                        onChange={(e) => {
                                          formik.handleChange(e);
                                        }}
                                      >
                                        <option value={order_item.production_out.productionout_id} selected>
                                          {order_item.production_out.barcode_number}
                                        </option>
                                      </select>
                                    </td>
                                    <td style={{ width: "16%" }}>
                                      {order_item.products.map((prod, prodIndex) => (
                                        <div className="form-group" key={prod.ggn_number || prodIndex}>
                                          <input
                                            type="text"
                                            className="form-input form-control"
                                            name={`contents[${index}].ggn_number`}
                                            readOnly={true}
                                            value={prod.ggn_number}
                                            onChange={formik.handleChange}
                                          />
                                        </div>
                                      ))}
                                    </td>
                                    <td style={{ width: "22%" }}>
                                      {order_item.products.map((prod, prodIndex) => (
                                        <div className="form-group" key={prod.product || prodIndex}>
                                          <select
                                            className="form-select form-control"
                                            name={`contents[${index}].product`}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={prod.product}
                                            defaultValue={prod.product}
                                          >
                                            <option value={prod.product} selected>
                                              {prod.product_name}
                                            </option>
                                          </select>
                                        </div>
                                      ))}
                                    </td>
                                    <td style={{ width: "10%" }}>
                                      {order_item.products.map((prod, prodIndex) => (
                                        <div className="form-group" key={prod.lot_number || prodIndex}>
                                          <input
                                            type="text"
                                            className="form-input form-control"
                                            name={`contents[${index}].lot_number`}
                                            readOnly={true}
                                            value={prod.lot_number}
                                            onChange={formik.handleChange}
                                          />
                                        </div>
                                      ))}
                                    </td>
                                    <td style={{ width: "10%" }}>
                                      {order_item.products.map((prod, prodIndex) => (
                                        <div className="form-group" key={prod.calibre || prodIndex}>
                                          <input
                                            type="text"
                                            className="form-input form-control"
                                            name={`contents[${index}].calibre`}
                                            readOnly={true}
                                            value={prod.calibre}
                                            onChange={formik.handleChange}
                                          />
                                        </div>
                                      ))}
                                    </td>
                                    <td style={{ width: "10%" }}>
                                      {order_item.products.map((prod, prodIndex) => (
                                        <div className="form-group" key={prod.number_of_boxes || prodIndex}>
                                          <input
                                            type="text"
                                            className="form-input form-control"
                                            name={`contents[${index}].number_of_boxes`}
                                            readOnly={true}
                                            value={prod.number_of_boxes}
                                            onChange={formik.handleChange}
                                          />
                                        </div>
                                      ))}
                                    </td>
                                    <td style={{ width: "10%" }}>
                                      {order_item.products.map((prod, prodIndex) => (
                                        <div className="form-group" key={prod.net_weight || prodIndex}>
                                          <input
                                            type="text"
                                            className="form-input form-control"
                                            name={`contents[${index}].net_weight`}
                                            readOnly={true}
                                            value={prod.net_weight}
                                            onChange={formik.handleChange}
                                          />
                                        </div>
                                      ))}
                                    </td>
                                    <td style={{ width: "10%" }}>
                                      {order_item.products.map((prod, prodIndex) => (
                                        <div className="form-group" key={prod.gross_weight || prodIndex}>
                                          <input
                                            type="text"
                                            className="form-input form-control"
                                            name={`contents[${index}].gross_weight`}
                                            readOnly={true}
                                            value={prod.gross_weight}
                                            onChange={formik.handleChange}
                                          />
                                        </div>
                                      ))}
                                    </td>
                                  </tr>
                                </tbody>
                              ))}

                               
                            
                               </table>
                          )}
                        />

                        </div>
                        <div id="new-production" style={{display:'none'}}>
                          
                        <div className="row">
                          <div className="col-md-6">
                            <h4 className="card-title">
                              <br />
                              Items
                            </h4>
                          </div>
                        </div>
                        <FieldArray
                          name="items"
                          render={(arrayHelpers) => (
                            <div>
                              <button
                                className="btn btn-primary mb-3"
                                type="button"
                                onClick={() => {
                                 
                                  var  pallet_number=1;
                                  let appendArr233 =arrayHelpers.form.values.items;
                                 
                                  console.log("appendArr233");
                                  if(appendArr233.length >0){
                                    var arrlength =  appendArr233.length
                                    pallet_number = ++arrlength;
                                  }
                                  let initialArr ={
                                    pallet_number:pallet_number,
                                    product: "",
                                    lot_number: "",
                                    calibre: "",
                                    ggn_number: "",
                                    packaging_type: "",
                                    number_of_boxes: "",
                                    price: "",
                                    net_weight: "",
                                    gross_weight: "",
                                   
                                   }
                                   //appendArr = (appendArr)?appendArr:initialArr;
                                  arrayHelpers.push(initialArr);
                                  setShowTableHeadings(true);
                                 console.log(arrayHelpers);
                                }}
                              >
                                +
                              </button>
                              <table>
                                    {showTableHeadings && (
                                      <thead>
                                        <tr>
                                          <td style={{ width: "6%" }}>Pallet</td>
                                          <td style={{ width: "12%" }}>Product</td>
                                          <td style={{ width: "8%" }}>Lot Number</td>
                                          <td style={{ width: "8%" }}>Caliber</td>
                                          <td style={{ width: "12%" }}>GGN Number</td>
                                          <td style={{ width: "12%" }}>Packaging Type</td>
                                          <td style={{ width: "8%" }}>No of Boxes</td>
                                          <td style={{ width: "8%" }}>Price</td>
                                          <td style={{ width: "12%" }}>Net Weight</td>
                                          <td style={{ width: "12%" }}>Gross Weight</td>
                                          <td style={{ width: "2%" }}></td>
                                        </tr>
                                      </thead>
                                    )}

                                    {formik.values.items.map((friend, index) => (
                                      <tbody  key={index}>
                                        <tr  key={index}>
                                          <td>
                                            <div className="form-group">
                                              <input
                                                type="text"
                                                style={inputStyle}
                                                onWheel={handleWheel}
                                                className="form-input form-control"
                                                name={`items[${index}].pallet_number`}
                                                value={formik.values.items[index].pallet_number}
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                          <div className="form-group">
                                          <Select
                                             name={`items[${index}].product`}
                                             options={productLists}
                                             value={productLists.find(option => option.value == formik.values.items[index].product) || null} // Ensure correct format
                                             onChange={(selectedOption) => {
                                               formik.setFieldValue(`items[${index}].product`, selectedOption.value); // ✅ Store only value in Formik
                                               customHandleInput({
                                                 target: {
                                                   name: `items[${index}].product`,
                                                   value: selectedOption.value, // ✅ Ensure only value is passed
                                                 },
                                               });
                                             }}
                                             onBlur={formik.handleBlur}
                                             placeholder="Select"
                                             className="w-100"
                                            />
                                          </div>
                                          </td>
                                          <td>
                                            <div className="form-group ">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`items[${index}].lot_number`}
                                                value={formik.values.items[index].lot_number}
                                                placeholder="Lot Number"
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className="form-group ">
                                              <input
                                                type="text"
                                                className="form-input form-control"
                                                name={`items[${index}].calibre`}
                                                value={formik.values.items[index].calibre}
                                                placeholder="calibre"
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                          <div className="form-group">
                                          <Select
                                           name={`items[${index}].ggn_number`}
                                           options={ggnLists}
                                           value={ggnLists.find(option => option.value == formik.values.items[index].ggn_number) || null} // Ensure correct format
                                           onChange={(selectedOption) => {
                                             formik.setFieldValue(`items[${index}].ggn_number`, selectedOption.value); // ✅ Store only value in Formik
                                             customHandleInput({
                                               target: {
                                                 name: `items[${index}].ggn_number`,
                                                 value: selectedOption.value, // ✅ Ensure only value is passed
                                               },
                                             });
                                           }}
                                           onBlur={formik.handleBlur}
                                           placeholder="Select"
                                           className="w-100"

                                              // className="w-100"
                                              // name={`items[${index}].ggn_number`}
                                              // data={ggnLists}
                                              // value={formik.values.items[index].ggn_number}
                                              // onChange={formik.handleChange}
                                              // onBlur={formik.handleBlur}
                                              // options={{
                                              //   placeholder: "Select GGN Number",
                                              // }}
                                            />
                                          </div>
                                          </td>
                                          <td>
                                            <div className="form-group ">
                                              <Select
                                              name={`items[${index}].packaging_type`}
                                              options={packagingTypesLists}
                                              value={packagingTypesLists.find(option => option.value == formik.values.items[index].packaging_type) || null} // Ensure correct format
                                              onChange={(selectedOption) => {
                                                formik.setFieldValue(`items[${index}].packaging_type`, selectedOption.value); // ✅ Store only value in Formik
                                                customHandleInput({
                                                  target: {
                                                    name: `items[${index}].packaging_type`,
                                                    value: selectedOption.value, // ✅ Ensure only value is passed
                                                  },
                                                });
                                              }}
                                              onBlur={formik.handleBlur}
                                              placeholder="Select"
                                              className="w-100"

                                                // className="w-100"
                                                // name={`items[${index}].packaging_type`}
                                                // data={packagingTypesLists}
                                                // value={formik.values.items[index].packaging_type}
                                                // onChange={formik.handleChange}
                                                // onBlur={formik.handleBlur}
                                                // options={{
                                                //   placeholder: "Select Packaging Type",
                                                // }}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className="form-group">
                                              <input
                                                type="text"
                                                style={inputStyle}
                                                onWheel={handleWheel}
                                                placeholder=" Boxes"
                                                className="form-input form-control"
                                                name={`items[${index}].number_of_boxes`}
                                                value={formik.values.items[index].number_of_boxes}
                                                onChange={(e) => {
                                                  formik.handleChange(e);
                                                  handleNumericInput(e);
                                                }}
                                                onKeyPress={(event) => {
                                                  // Prevent non-numeric input for keypress
                                                  if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                // onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <div className="form-group">
                                            <div className="input-group">
                                            <input
                                                type="text"
                                                style={inputStyle}
                                                onWheel={handleWheel}
                                                name={`items[${index}].price`}
                                                value={formik.values.items[index].price}
                                                onKeyPress={(event) => {
                                                  // Prevent non-numeric input for keypress
                                                  if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                // onChange={formik.handleChange}
                                                onChange={(e) => {
                                                  formik.handleChange(e);
                                                  handleNumericInput(e);
                                                }}
                                                onBlur={formik.handleBlur}
                                                className="form-control"
                                                placeholder="Price"
                                                aria-label="Price"
                                                aria-describedby="basic-addon2"
                                              />
                                              <div className="input-group-append">
                                                <span className="input-group-text" id="basic-addon2">
                                                  {currencySymbol}
                                                </span>
                                              </div>
                                            </div>
                                              
                                            </div>
                                          </td>
                                          <td>
                                            <div className="form-group">
                                            <div className="input-group">
                                            <input
                                                type="text"
                                                style={inputStyle}
                                                onWheel={handleWheel}
                                                name={`items[${index}].net_weight`}
                                                value={formik.values.items[index].net_weight}
                                                // onChange={formik.handleChange}
                                                onChange={(e) => {
                                                  formik.handleChange(e);
                                                  handleNumericInput(e);
                                                      // Calculate the total after the field value is fully updated
                                                      const updatedItems = [...formik.values.items];
                                                      updatedItems[index].net_weight = e.target.value;

                                                      formik.setFieldValue(
                                                        'total_net_weight',
                                                        calculateTotalWeight(updatedItems, 'net_weight')
                                                      );
                                                }}
                                                onKeyPress={(event) => {
                                                  if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                onBlur={formik.handleBlur}
                                                className="form-control"
                                                placeholder="Net Weight"
                                                aria-label="Net Weight"
                                                aria-describedby="basic-addon2"
                                              />
                                              <div className="input-group-append">
                                                <span className="input-group-text" id="basic-addon2">
                                                  KG
                                                </span>
                                              </div>
                                            </div>
                                             
                                            </div>
                                          </td>
                                          <td>
                                            <div className="form-group">
                                            <div className="input-group">
                                            <input
                                                type="text"
                                                style={inputStyle}
                                                onWheel={handleWheel}
                                                name={`items[${index}].gross_weight`}
                                                value={formik.values.items[index].gross_weight}
                                                // onChange={formik.handleChange}
                                                onChange={(e) => {
                                                  formik.handleChange(e);
                                                  handleNumericInput(e);
                                                  // Calculate the total after the field value is fully updated
                                                  const updatedItems = [...formik.values.items];
                                                  updatedItems[index].gross_weight = e.target.value;

                                                  formik.setFieldValue(
                                                    'total_brut_weight',
                                                    calculateTotalWeight(updatedItems, 'gross_weight')
                                                  );
                                                }}
                                               onKeyPress={(event) => {
                                                  if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                onBlur={formik.handleBlur}
                                                className="form-control"
                                                placeholder="Gross Weight"
                                                aria-label="Gross Weight"
                                                aria-describedby="basic-addon2"
                                              />
                                              <div className="input-group-append">
                                                <span className="input-group-text" id="basic-addon2">
                                                  KG
                                                </span>
                                              </div>
                                            </div>
                                             
                                            </div>
                                          </td>
                                          <td>
                                            <div className="form-group">
                                              <button
                                                className="btn btn-danger"
                                                // style={{ marginTop: 30 }}
                                                type="button"
                                                onClick={() => arrayHelpers.remove(index)}
                                              >
                                                -
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    ))}
                                  </table>

                         
                            </div>
                          )}
                        />


                        </div>

                     
                        <div className="text-end mt-4">
                          <button className="btn btn-primary" type="submit" id="form-submit" disabled={formik.isSubmitting}>
                          Add Supply Chain Packaging
                          </button>
                        </div>
                      </form>
                    </FormikProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SupplychainPackagelistHeadersAdd;
